import {LitElement, html, css} from 'lit';
import {connect} from 'pwa-helpers';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg} from '@lit/localize';
import store from '../../../store';
import {cssProperties} from '../../../css/cssProperties';
import {luminaryOptions} from '../../../sectionConfig';

@customElement('page-luminare-all-available')
export class PageLuminareAllAvailable extends connect(store)(LitElement) {

	static styles = [
		css`
		.lampsSection {
			display: block;
		}

		.description p {
			color: var(--color-black);
			font: var(--font-specsheet-print-light);
			line-height: 14px;
			margin-bottom: 20px;
			max-width: 40%;
			text-align: left;
		}

		.lampsGrid {
			margin-top: 30px;
			max-width: 96vw;
		}

		.flex-item {
			display: table-cell;
			padding-right: 30px;
			width: 30vw;
		}

		.lampContainer {
			margin: 35px 20px;
			position: relative;
		}

		.lampDescription {
			color: var(--color-black);
			font: var(--font-specsheet-print-light);
			line-height: 12px;
			letter-spacing: 0.2px;
		}

		.lampDescription span {
			font: var(--font-specsheet-print-bold);
		}

		.imgContainer {
			border-bottom: 1px solid #C6C6C6;
			text-align: center;
			width: 100%;
		}

		.imgContainer img {
			margin: auto;
			margin-bottom: -4px;
			height: 15vw;
		}

		@media (max-width: 768px) {
			.lampsSection {
				display: block;
				padding: 0;
			}
			.description {
				max-width: 100%;
			}
			.lampsGrid {
				margin-top: 30px;
				max-width: 96vw;
			}
		}
		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.translations = state.productData.translations;
		this.decisions = state.decisions.data;
		this.profile = state.lightProfile.data.profile;
		this.lightProfile = state.lightProfile.data;
		this.lang = state.status.lang;
	}
	render() {
		const s = this.state;
		const luminaryElements = luminaryOptions.map(luminary => {
			const image = luminary.imageWhite;
			const label = luminary.label[this.lang] || '';
			const description = luminary.description[this.lang] || '';
			const canBeSelected = luminary.availableForLightProfiles.includes(s.lightProfile.data.project.base);
			return canBeSelected ? html`
			<div class="lampContainer flex-item">
				<div class="imgContainer">
					<img alt="Luminaire" src="${image}" />
				</div>
				<p class="lampDescription"><span>${label} </span>${description}</p>
			</div>
			`: html``;
		});
		const row1 = luminaryElements.slice(0, 3);
		const row2 = luminaryElements.slice(3, 4);

		return html`
		<specsheet-light-section>
			<page-header content-title="${msg('Available luminaires')}" ></page-header>
			<section class="lampsSection">
				<div class="description">
					<p></p>
				</div>
				<div class="lampsGrid">
					${row1}
				</div>
				<div class="lampsGrid">
					${row2}
				</div>
			</section>
			<page-footer></page-footer>
		`;
	}
}
